/*
SESSION TYPES:
- presentation
  - presentation with author
- meta
  - other than presentations such as coffee break, etc.
  - for meta sessions without defined track will be populated cross session `track`
*/

const FIRST_DAY = '2018-03-03'
const SECOND_DAY = '2018-03-04'

const track1 = 'track1'
const track2 = 'track2'
const workshop1 = 'workshop1'
const workshop2 = 'workshop2'

export default [
  {
    date: FIRST_DAY,
    time: '10:00-10:55',
    track: track1,
    presentation: 'barinka-bash',
  },
  {
    date: FIRST_DAY,
    time: '11:00-11:55',
    track: track1,
    presentation: 'pavlik-spectre-meltdown',
  },
  {
    date: FIRST_DAY,
    time: '12:00-12:25',
    track: track1,
    presentation: 'miler-hesla',
  },
  {
    date: FIRST_DAY,
    time: '14:00-14:25',
    track: track1,
    presentation: 'holecek-pxe',
  },
  {
    date: FIRST_DAY,
    time: '14:30-14:55',
    track: track1,
    presentation: 'hala-dnssec',
  },
  {
    date: FIRST_DAY,
    time: '15:00-15:55',
    track: track1,
    presentation: 'franc-vyvoj',
  },
  {
    date: FIRST_DAY,
    time: '16:00-16:25',
    track: track1,
    presentation: 'zandl-turris',
  },
  {
    date: FIRST_DAY,
    time: '16:30-17:25',
    track: track1,
    presentation: 'cejka-nmap',
  },
  {
    date: FIRST_DAY,
    time: '11:00-11:55',
    track: track2,
    presentation: 'koci-wifi',
  },
  {
    date: FIRST_DAY,
    time: '12:00-12:55',
    track: track2,
    presentation: 'stehlik-orange-pi',
  },
  {
    date: FIRST_DAY,
    time: '14:00-14:25',
    track: track2,
    presentation: 'hodac-vim',
  },
  {
    date: FIRST_DAY,
    time: '14:30-14:55',
    track: track2,
    presentation: 'pulec-ssh',
  },
  {
    date: FIRST_DAY,
    time: '15:00-15:55',
    track: track2,
    presentation: 'vondra-virt',
  },
  {
    date: FIRST_DAY,
    time: '16:00-16:25',
    track: track2,
    presentation: 'ansorgova-dokumentacia',
  },
  {
    date: FIRST_DAY,
    time: '16:30-16:55',
    track: track2,
    presentation: 'polasek-plosne-spoje',
  },
  {
    date: FIRST_DAY,
    time: '17:00-17:25',
    track: track2,
    presentation: 'sika-i3',
  },
  {
    date: SECOND_DAY,
    time: '10:00-10:55',
    track: track1,
    presentation: 'caletka-netiketa',
  },
  {
    date: SECOND_DAY,
    time: '11:00-11:25',
    track: track1,
    presentation: 'benes-reinstall',
  },
  {
    date: SECOND_DAY,
    time: '11:30-12:25',
    track: track1,
    presentation: 'krcmar-sifrovany-disk',
  },
  {
    date: SECOND_DAY,
    time: '14:00-14:55',
    track: track1,
    presentation: 'becvarik-virtualy',
  },
  {
    date: SECOND_DAY,
    time: '15:00-15:25',
    track: track1,
    presentation: 'baler-wireguard',
  },
  {
    date: SECOND_DAY,
    time: '15:30-16:25',
    track: track1,
    presentation: 'becvarik-domaci-bydleni',
  },
  {
    date: SECOND_DAY,
    time: '10:00-10:55',
    track: track2,
    presentation: 'sojka-openwrt',
  },
  {
    date: SECOND_DAY,
    time: '11:00-11:25',
    track: track2,
    presentation: 'snajdr-vpsadminos',
  },
  {
    date: SECOND_DAY,
    time: '11:30-12:25',
    track: track2,
    presentation: 'kaplan-icinga',
  },
  {
    date: SECOND_DAY,
    time: '14:00-14:55',
    track: track2,
    presentation: 'ziegler-sitove-simulatory',
  },
  {
    date: SECOND_DAY,
    time: '15:00-15:25',
    track: track2,
    presentation: 'bedrich-python',
  },
  {
    date: SECOND_DAY,
    time: '15:30-15:55',
    track: track2,
    presentation: 'vician-linux',
  },
  {
    date: SECOND_DAY,
    time: '16:00-16:25',
    track: track2,
    presentation: 'veverka-docker',
  },
  {
    date: FIRST_DAY,
    time: '11:00-13:55',
    track: workshop1,
    presentation: 'hroncok-hra-python',
  },
  {
    date: FIRST_DAY,
    time: '14:00-14:55',
    track: workshop1,
    presentation: 'novy-stec-zabezpeceni',
  },
  {
    date: FIRST_DAY,
    time: '15:00-15:55',
    track: workshop1,
    presentation: 'uhlik-vi',
  },
  {
    date: FIRST_DAY,
    time: '16:00-16:55',
    track: workshop1,
    presentation: 'vondra-vykon',
  },
  {
    date: FIRST_DAY,
    time: '11:00-12:55',
    track: workshop2,
    presentation: 'jilek-cmd',
  },
  {
    date: FIRST_DAY,
    time: '14:00-15:55',
    track: workshop2,
    presentation: 'pluskal-opensuse',
  },
  {
    date: FIRST_DAY,
    time: '16:00-16:55',
    track: workshop2,
    presentation: 'puzman-archlinux',
  },
  {
    date: SECOND_DAY,
    time: '11:00-12:55',
    track: workshop1,
    presentation: 'iliushin-hacking-101',
  },
  {
    date: SECOND_DAY,
    time: '15:15-17:15',
    track: workshop1,
    presentation: 'ziegler-sitove-simulatory-ws',
  },
  {
    date: SECOND_DAY,
    time: '11:00-12:55',
    track: workshop2,
    presentation: 'caletka-ripe',
  },
  {
    date: SECOND_DAY,
    time: '15:15-17:15',
    track: workshop2,
    presentation: 'zapletal-foreman',
  },
]



// WEBPACK FOOTER //
// ./src/content/installfest/data/sessions.js